'use client'

import React from 'react'
import { X } from 'lucide-react'
import toast from 'react-hot-toast'

import { useIsDesktop } from '@rewardops/ui'

import { useTranslation } from '~/app/i18n/client'

const ErrorToastContent = ({
  t,
  messages,
}: {
  t: any
  messages: { exclamation: string; message: string }
}) => {
  return (
    <div
      style={{
        display: 'flex',
        minWidth: '100%',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div>
          <span style={{ fontWeight: '700' }}>{messages.exclamation}</span>{' '}
          {messages.message}
        </div>
      </div>
      <button
        onClick={() => {
          toast.dismiss(t.id)
        }}
      >
        <X />
      </button>
    </div>
  )
}

export const useErrorToast = () => {
  const isDesktop = useIsDesktop()
  const { t: translation } = useTranslation()

  const triggerErrorToast = (customMessages?: {
    exclamation?: string
    message?: string
  }) => {
    const defaultMessages = {
      exclamation: translation('genericErrorToast.exclamation'),
      message: translation('genericErrorToast.message'),
    }

    const messages = {
      ...defaultMessages,
      ...customMessages, // Override defaults if customMessages are provided
    }

    toast((t) => <ErrorToastContent t={t} messages={messages} />, {
      id: 'error-toast',
      duration: Infinity,
      position: 'top-center',
      style: {
        minWidth: isDesktop ? '474px' : '324px',
        minHeight: '100px',
        backgroundColor: '#FAF2F0',
        border: '1px solid #F6D2C6',
        borderRadius: '6px',
        color: '#E71D34',
        fontSize: isDesktop ? '16px' : '12px',
        fontWeight: '500',
      },
    })
  }

  return { triggerErrorToast }
}
